export const generateErrorId = (title: string): string => {
  return `${title}-error-message`.toLowerCase().replace(/\s+/g, "-")
}
